import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { extender } from "../../backend/class-extender";
import { AvailabilityBase } from "../availability-base";
import { Opportunity } from "../opportunity/entity";
import { OpportunityAvailabilityEntityConfig } from "./config";
import { OpportunityAvailabilityFilters } from "./filters";
import { OpportunityAvailabilityMethods } from "./methods";

@HyperEntity<OpportunityAvailability>(
  "opportunity-availability",
  OpportunityAvailabilityEntityConfig,
)
export class OpportunityAvailability extends extender(
  OpportunityAvailabilityFilters,
  OpportunityAvailabilityMethods,
  AvailabilityBase,
) {
  @Fields.string({
    required: true,
    dbName: "opportunity_id",
  })
  opportunityId!: string;

  @Relations.toOne<OpportunityAvailability, Opportunity>(
    () => Opportunity,
    "opportunityId",
  )
  opportunity?: Opportunity;
}
